import React, { useState } from 'react';
import DetailIcon from '@/common/detail-icon';
import classNames from 'classnames';
import Item from './item';
import MoreLess from '@/common/more-less/more-less';
import './index.less';

export default function Index(props: AttributeTypes.Root) {
  const {
    productKeyIndustryProperties = [],
    productOtherProperties = [],
    logisticInfo,
    tradeInfo,
    i18n,
  } = props;
  const [shown, setShown] = useState(
    productKeyIndustryProperties.length + productOtherProperties.length > 5 ? 1 : -1,
  );

  const {
    unitSize,
    unitVolume,
    unitWeight,
    productPackagingImages,
    productPackagingProperties,
    supplyAbility,
  } = logisticInfo;

  const { saleType = '', batchNum } = tradeInfo;

  const textMap = {
    imgTitle: i18n['detailModule.productPackaging.img'],
    cm: i18n['detailModule.productPackaging.cm'],
  };

  let sellingUnits = '';
  let wightName = '';
  let sizeName = '';

  // 按批售卖，否则按件
  if (saleType === 'batch') {
    sellingUnits = `${i18n['detailMarketPackage_selling_unit']} ${batchNum}`;
    wightName = i18n['detailMarketPackage_wight_name'];

    if (unitSize) {
      sizeName = i18n['detailMarketPackage_market_size_name'];
    } else {
      sizeName = i18n['detailMarketPackage_size_name'];
    }
  } else {
    sellingUnits = i18n['detailMarketPackage_selling_unit_single'];
    wightName = i18n['detailMarketPackage_wight_name_single'];

    if (unitSize) {
      sizeName = i18n['detailMarketPackage_market_size_name_single'];
    } else {
      sizeName = i18n['detailMarketPackage_size_name_single'];
    }
  }

  const renderPackage = () => {
    const list = [] as {
      attrName: string;
      attrValue: string | React.JSX.Element;
    }[];
    if (productPackagingProperties) {
      list.push(...productPackagingProperties);
    }
    if (unitSize) {
      list.push({
        attrName: i18n['detailMarketPackage_table_tr_unit'],
        attrValue: sellingUnits,
      });
      list.push({
        attrName: sizeName,
        attrValue: unitSize ? (
          `${unitSize} ${textMap.cm}`
        ) : (
          <>
            {`${unitVolume} ${textMap.cm}`}
            <sup>3</sup>
          </>
        ),
      });
      list.push({
        attrName: wightName,
        attrValue: `${unitWeight} ${i18n['detailModule.productPackaging.kg']}`,
      });
    }
    return list;
  };

  return (
    <div
      className={classNames({
        'attribute-layout': true,
        'show-more': shown === 1,
      })}
    >
      <h3 className="att-title" id="key-attributes">
        {i18n['PC_detail_spec_title']}
      </h3>
      <div className="attribute-info">
        <Item title={i18n['PC_detail_spec_keyattributes']} list={productKeyIndustryProperties} />
        <Item title={i18n['PC_detail_spec_otherattributes']} list={productOtherProperties} />
        {productPackagingImages && (
          <Item
            title={i18n['PC_detail_spec_packaging']}
            list={renderPackage()}
            images={productPackagingImages}
          />
        )}
        {supplyAbility && (
          <Item
            title={i18n['detailModule.supplyAbility.title']}
            list={[
              {
                attrName: i18n['detailModule.supplyAbility.title'],
                attrValue: supplyAbility,
              },
            ]}
          />
        )}
        {shown > -1 && (
          <MoreLess
            elementId="#key-attributes"
            logMoreName="/sc.details.attributeViewMore"
            logLessName="/sc.details.attributeViewLess"
            i18n={i18n}
            shown={shown}
            updateShown={(v: number) => setShown(v)}
          />
        )}
      </div>
    </div>
  );
}
